export async function logoutIvideon(dealerId: string): Promise<unknown> {
  const url = `/internal-api/ivideon/logout`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ dealerId }),
    });

    if (!response.ok) {
      let errorMessage = `HTTP error! Status: ${response.status}`;

      try {
        const errorData = await response.json();
        errorMessage = (errorData["message"] ??
          errorData["error"] ??
          errorMessage) as string;
      } catch {
        // Не удалось распарсить тело ответа, используем статус
      }

      const error = new Error(errorMessage);
      (error as unknown as Record<string, unknown>)["httpStatus"] =
        response.status;
      throw error;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка: ", error);
    throw error;
  }
}
